import { render } from "./ValidatorDefiLeaderboard.vue?vue&type=template&id=1c528a12&scoped=true"
import script from "./ValidatorDefiLeaderboard.vue?vue&type=script&lang=js"
export * from "./ValidatorDefiLeaderboard.vue?vue&type=script&lang=js"

import "./ValidatorDefiLeaderboard.vue?vue&type=style&index=0&id=1c528a12&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c528a12"],['__file',"resources/js/components/ValidatorDefiLeaderboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c528a12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c528a12', __exports__)) {
    api.reload('1c528a12', __exports__)
  }
  
  module.hot.accept("./ValidatorDefiLeaderboard.vue?vue&type=template&id=1c528a12&scoped=true", () => {
    api.rerender('1c528a12', render)
  })

}


export default __exports__